import React from 'react';
import './about.css';
import portfolioConfig from '../../config/portfolioConfig';

const About = () => {
  const { personal, principles } = portfolioConfig;

  return (
    <section id="about" className="about-section section">
      <div className="container about-section__container">
        <div className="about-section__intro">
          <p className="section-eyebrow">About</p>
          <h2>Cleaner product thinking, not trend-stacked decoration.</h2>
          <p className="section-copy">{personal.description}</p>
          <p className="section-copy">
            I enjoy turning rough ideas into something people can actually use. That usually
            means sharpening the structure, making the interface easier to trust, and keeping
            the code practical enough to keep shipping after the first launch.
          </p>

          <div className="about-facts">
            <div className="about-facts__item panel">
              <span>Based in</span>
              <strong>{personal.location}</strong>
            </div>
            <div className="about-facts__item panel">
              <span>Best fit</span>
              <strong>Web products and polished launches</strong>
            </div>
            <div className="about-facts__item panel">
              <span>Contact</span>
              <strong>{personal.email}</strong>
            </div>
          </div>
        </div>

        <div className="about-section__aside">
          <article className="about-portrait panel">
            <img src={personal.portraitImage} alt={personal.name} className="about-portrait__image" />
            <div className="about-portrait__content">
              <p className="section-eyebrow">Working style</p>
              <h3>Fast iteration, better visual judgment, fewer filler effects.</h3>
            </div>
          </article>

          <div className="about-principles">
            {principles.map((principle) => (
              <article key={principle.title} className="about-principles__card panel">
                <h3>{principle.title}</h3>
                <p>{principle.description}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
